module.exports = __webpack_public_path__ + "img/cover-anseio.fc5c1c9f.png";